var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStripeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.25 14.5V49.5C63.25 57.0887 57.0887 63.25 49.5 63.25H14.5C6.91125 63.25 0.75 57.0887 0.75 49.5V14.5C0.75 6.91113 6.91125 0.75 14.5 0.75H49.5C57.0887 0.75 63.25 6.91113 63.25 14.5Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#635BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6823 25.5138C29.6823 24.1391 30.832 23.6103 32.7366 23.6103C35.4676 23.6103 38.9174 24.4211 41.6483 25.8663V17.5823C38.6658 16.4189 35.7191 15.9607 32.7366 15.9607C25.4419 15.9607 20.5908 19.6973 20.5908 25.9369C20.5908 35.6662 34.2458 34.1152 34.2458 38.3101C34.2458 39.9317 32.8084 40.4603 30.7961 40.4603C27.8136 40.4603 24.0044 39.2619 20.9861 37.6403V46.0302C24.3279 47.4402 27.7058 48.0394 30.7961 48.0394C38.2706 48.0394 43.4093 44.4086 43.4093 38.0987C43.3733 27.5937 29.6823 29.4621 29.6823 25.5138Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeIcon);
export default __webpack_public_path__ + "static/media/stripeIcon.89abda85193cab5ac5abe8392ed19640.svg";
export { ForwardRef as ReactComponent };